
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works/how-to-upload",
      function () {
        return require("private-next-pages/how-it-works/how-to-upload.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-it-works/how-to-upload"])
      });
    }
  